import React from 'react'
import AutoForm from '@components/AutoForm'
import Button from '@components/Button'
import ObjectField from '@components/fields/ObjectField'
import withUserId from '@helpers/auth/withUserId'
import Text from '@packages/justo-parts/lib/components/fields/Text'
import saveJWT from '@providers/apollo/saveJWT'
import autobind from 'autobind-decorator'
import Link from 'next/link'
import {TFunction, withTranslation} from 'next-i18next'
import {Field} from 'simple-react-form'

import LoggedIn from '../LoggedIn'

export interface RegisterProps {
  onLogin: any
  userId?: string
  t: TFunction
}

// @ts-expect-error ts-migrate(1238) FIXME: Unable to resolve signature of class decorator whe... Remove this comment to see the full error message
@withUserId
class Register extends React.Component<RegisterProps> {
  form = React.createRef()

  @autobind
  async onSuccess(session) {
    console.log('Saving new session JWT')
    await saveJWT(session)

    await this.props.onLogin()
  }

  render() {
    if (this.props.userId) return <LoggedIn />
    return (
      <div>
        <AutoForm mutation="createUser" ref={this.form} onSuccess={this.onSuccess}>
          <Field fieldName="profile" type={ObjectField} style={null}>
            <div className="row">
              <div className="col-xs-12 col-sm-6">
                <div className="label">{this.props.t('name')}</div>
                <Field fieldName="firstName" type={Text} placeholder={this.props.t('name')} />
              </div>
              <div className="col-xs-12 col-sm-6">
                <div className="label">{this.props.t('lastName')}</div>
                <Field fieldName="lastName" type={Text} placeholder={this.props.t('lastName')} />
              </div>
            </div>
          </Field>
          <div className="label">Email</div>
          <Field fieldName="email" type={Text} fieldType="email" placeholder="Email" />
          <div className="label">{this.props.t('password')}</div>
          <Field
            fieldName="password"
            type={Text}
            fieldType="password"
            placeholder={this.props.t('password')}
          />
        </AutoForm>
        <br />
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'submit' does not exist on type 'unknown'... Remove this comment to see the full error message */}
        <Button onClick={() => this.form?.current?.submit()} primary>
          {this.props.t('createAccount')}
        </Button>
        <br />
        <br />
        <div>
          {this.props.t('ifYouHaveAnAccount')}{' '}
          <Link passHref href="/login" legacyBehavior>
            {this.props.t('login')}
          </Link>
        </div>
      </div>
    );
  }
}

export default withTranslation('auth')(Register)
